export const FileType = {
    /**
     * 建筑
     */
    // BUILDING: 1,
    /**
     * 物理模型
     */
    MODEL_PHYSICS: 2,
    /**
     * 功能模型
     */
    MODEL_FUNCTION: 3,
    /**
     * 图纸
     */
    DRAWING: 4,
    /**
     * 报告
     */
    REPORT: 5,
    /**
     * 图片
     */
    IMAGE: 6,
}

export const FileTypeList = [
    // { value: "1", label: '建筑' },
    { value: "2", label: '物理模型' },
    { value: "3", label: '功能模型' },
    { value: "4", label: '图纸' },
    { value: "5", label: '报告' },
    { value: "6", label: '图片' },
]

export const ChangeFileTypeList = [
    { value: "2", label: '物理模型' },
    { value: "3", label: '功能模型' },
    { value: "4", label: '图纸' },
    { value: "5", label: '报告' },
    { value: "6", label: '图片' },
]

export function getFileTypeLabel(type) {
    return FileTypeList.find(item => item.value === type)?.label || ""
}
